<template>
  <v-generic-input
    :label="label"
    :translate-text="translateText"
    :help-text="helpText"
    :id="`${givenId}`"
    :required="required"
    :errors="errors"
  >
    <template v-slot:input>
      <div :class="[horizontal ? 'd-flex justify-content-between': '']">
        <label
          :id="`label-${givenId}-${option.key}`"
          class="w-100"
          :class="getRadioButtonClass(option)"
          v-for="option in choices"
          :key="option.key"
        >
          <input
            :id="`${givenId}-${option.key}`"
            type="radio"
            :disabled="disabled"
            :name="`${givenId}-${option.key}`"
            :value="option.key"
            v-model="inputVal"
          />
          <i
            class="mr-2"
            v-if="option.icon"
            :class="[option.icon]"
          />
          {{ getChoiceText(option.value) }}
        </label>
      </div>
    </template>
  </v-generic-input>
</template>

<script>
import { GenericInputMixin } from '@/common/utils/mixins';
import _GenericInput from './_GenericInput.vue';

export default {
  name: 'RadioButtons',
  components: {
    'v-generic-input': _GenericInput,
  },
  props: {
    buttonStyle: {
      type: String,
      default() {
        return 'default';
      },
    },
    choices: {
      required: true,
    },
    disabled: {
      type: Boolean,
      default() {
        return false;
      },
    },
    horizontal: {
      type: Boolean,
      default() {
        return false;
      },
    },
    value: {
      type: String,
    },
  },
  mixins: [
    GenericInputMixin,
  ],
  methods: {
    getChoiceText(value) {
      if (this.translateText) {
        return this.$t(value);
      }
      return value;
    },
    getRadioButtonClass(option) {
      const buttonClass = [`radio-${this.buttonStyle}`];
      if (option.key === this.inputVal) {
        buttonClass.push(`radio-${this.buttonStyle}-active`);
      }
      return buttonClass;
    },
  },
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  data() {
    return {
      givenId: null,
    };
  },
  mounted() {
    // eslint-disable-next-line no-underscore-dangle
    this.givenId = this.id || this._uid;
  },
};
</script>

<style scoped>
.radio-default {
  display: block;
}

.radio-blocks {
  display: block;
  transition: background 0.3s;
  background: #8897AA;
  padding: 5px;
  border-radius: 5px;
  margin: 3px;
  text-align: center;
  color: white;
}

.radio-blocks:hover {
  background: #6C7A92;
}

.radio-blocks-active {
  background: #465362;
}

.radio-blocks input {
  display: none;
}
</style>
